module.exports = __webpack_public_path__ + "img/ilifestyle_screen01.8dd3cff0.png";